package org.zest.insan_360_website.data

import org.zest.insan_360_website.model.Attribute
import org.zest.insan_360_website.model.GraphType

data class PlotPoint(val number: Int, val interval: Int, val attr: Attribute, val type: GraphType)

object GraphFormat {
    val GRAPH_FORMAT_MORE = listOf(
        PlotPoint(0,18, Attribute.Dominance, GraphType.More),
        PlotPoint(1, 32, Attribute.Dominance, GraphType.More),
        PlotPoint(2, 48, Attribute.Dominance, GraphType.More),
        PlotPoint(3, 66, Attribute.Dominance, GraphType.More),
        PlotPoint(4, 81, Attribute.Dominance, GraphType.More),
        PlotPoint(5, 85, Attribute.Dominance, GraphType.More),
        PlotPoint(6, 93, Attribute.Dominance, GraphType.More),
        PlotPoint(7, 103, Attribute.Dominance, GraphType.More),
        PlotPoint(8, 107, Attribute.Dominance, GraphType.More),
        PlotPoint(9, 115, Attribute.Dominance, GraphType.More),
        PlotPoint(10, 130, Attribute.Dominance, GraphType.More),
        PlotPoint(11, 136, Attribute.Dominance, GraphType.More),
        PlotPoint(12, 142, Attribute.Dominance, GraphType.More),
        PlotPoint(13, 152, Attribute.Dominance, GraphType.More),
        PlotPoint(14, 159, Attribute.Dominance, GraphType.More),
        PlotPoint(15, 178, Attribute.Dominance, GraphType.More),
        PlotPoint(16, 183, Attribute.Dominance, GraphType.More),
        PlotPoint(21, 188, Attribute.Dominance, GraphType.More),
        PlotPoint(0, 10, Attribute.Influence, GraphType.More),
        PlotPoint(1, 38, Attribute.Influence, GraphType.More),
        PlotPoint(2, 66, Attribute.Influence, GraphType.More),
        PlotPoint(3, 85, Attribute.Influence, GraphType.More),
        PlotPoint(4, 107, Attribute.Influence, GraphType.More),
        PlotPoint(5, 130, Attribute.Influence, GraphType.More),
        PlotPoint(6, 136, Attribute.Influence, GraphType.More),
        PlotPoint(7, 159, Attribute.Influence, GraphType.More),
        PlotPoint(8, 166, Attribute.Influence, GraphType.More),
        PlotPoint(9, 173, Attribute.Influence, GraphType.More),
        PlotPoint(11, 183, Attribute.Influence, GraphType.More),
        PlotPoint(19, 188, Attribute.Influence, GraphType.More),
        PlotPoint(0, 27, Attribute.Steadiness, GraphType.More),
        PlotPoint(1, 44, Attribute.Steadiness, GraphType.More),
        PlotPoint(2, 52, Attribute.Steadiness, GraphType.More),
        PlotPoint(3, 81, Attribute.Steadiness, GraphType.More),
        PlotPoint(4, 89, Attribute.Steadiness, GraphType.More),
        PlotPoint(5, 103, Attribute.Steadiness, GraphType.More),
        PlotPoint(6, 107, Attribute.Steadiness, GraphType.More),
        PlotPoint(7, 126, Attribute.Steadiness, GraphType.More),
        PlotPoint(8, 130, Attribute.Steadiness, GraphType.More),
        PlotPoint(9, 142, Attribute.Steadiness, GraphType.More),
        PlotPoint(10, 152, Attribute.Steadiness, GraphType.More),
        PlotPoint(12, 166, Attribute.Steadiness, GraphType.More),
        PlotPoint(14, 178, Attribute.Steadiness, GraphType.More),
        PlotPoint(20, 188, Attribute.Steadiness, GraphType.More),
        PlotPoint(0, 18, Attribute.Compliance, GraphType.More),
        PlotPoint(1, 38, Attribute.Compliance, GraphType.More),
        PlotPoint(2, 52, Attribute.Compliance, GraphType.More),
        PlotPoint(3, 81, Attribute.Compliance, GraphType.More),
        PlotPoint(4, 102, Attribute.Compliance, GraphType.More),
        PlotPoint(5, 115, Attribute.Compliance, GraphType.More),
        PlotPoint(6, 130, Attribute.Compliance, GraphType.More),
        PlotPoint(7, 159, Attribute.Compliance, GraphType.More),
        PlotPoint(8, 166, Attribute.Compliance, GraphType.More),
        PlotPoint(9, 173, Attribute.Compliance, GraphType.More),
        PlotPoint(11, 178, Attribute.Compliance, GraphType.More),
        PlotPoint(13, 183, Attribute.Compliance, GraphType.More),
        PlotPoint(17, 188, Attribute.Compliance, GraphType.More),
    )

    val GRAPH_FORMAT_LESS = listOf(
        PlotPoint(0, 4, Attribute.Dominance, GraphType.Less),
        PlotPoint(1, 15, Attribute.Dominance, GraphType.Less),
        PlotPoint(2, 44, Attribute.Dominance, GraphType.Less),
        PlotPoint(3, 66, Attribute.Dominance, GraphType.Less),
        PlotPoint(4, 81, Attribute.Dominance, GraphType.Less),
        PlotPoint(5, 91, Attribute.Dominance, GraphType.Less),
        PlotPoint(6, 99, Attribute.Dominance, GraphType.Less),
        PlotPoint(7, 107, Attribute.Dominance, GraphType.Less),
        PlotPoint(8, 111, Attribute.Dominance, GraphType.Less),
        PlotPoint(9, 126, Attribute.Dominance, GraphType.Less),
        PlotPoint(10, 132, Attribute.Dominance, GraphType.Less),
        PlotPoint(11, 138, Attribute.Dominance, GraphType.Less),
        PlotPoint(12, 148, Attribute.Dominance, GraphType.Less),
        PlotPoint(13, 162, Attribute.Dominance, GraphType.Less),
        PlotPoint(14, 168, Attribute.Dominance, GraphType.Less),
        PlotPoint(15, 173, Attribute.Dominance, GraphType.Less),
        PlotPoint(16, 178, Attribute.Dominance, GraphType.Less),
        PlotPoint(20, 188, Attribute.Dominance, GraphType.Less),
        PlotPoint(0, 10, Attribute.Influence, GraphType.Less),
        PlotPoint(1, 19, Attribute.Influence, GraphType.Less),
        PlotPoint(2, 49, Attribute.Influence, GraphType.Less),
        PlotPoint(3, 66, Attribute.Influence, GraphType.Less),
        PlotPoint(4, 91, Attribute.Influence, GraphType.Less),
        PlotPoint(5, 99, Attribute.Influence, GraphType.Less),
        PlotPoint(6, 115, Attribute.Influence, GraphType.Less),
        PlotPoint(7, 139, Attribute.Influence, GraphType.Less),
        PlotPoint(8, 148, Attribute.Influence, GraphType.Less),
        PlotPoint(9, 162, Attribute.Influence, GraphType.Less),
        PlotPoint(10, 173, Attribute.Influence, GraphType.Less),
        PlotPoint(11, 178, Attribute.Influence, GraphType.Less),
        PlotPoint(12, 183, Attribute.Influence, GraphType.Less),
        PlotPoint(19, 188, Attribute.Influence, GraphType.Less),
        PlotPoint(0, 4, Attribute.Steadiness, GraphType.Less),
        PlotPoint(1, 10, Attribute.Steadiness, GraphType.Less),
        PlotPoint(2, 19, Attribute.Steadiness, GraphType.Less),
        PlotPoint(3, 49, Attribute.Steadiness, GraphType.Less),
        PlotPoint(4, 66, Attribute.Steadiness, GraphType.Less),
        PlotPoint(5, 81, Attribute.Steadiness, GraphType.Less),
        PlotPoint(6, 91, Attribute.Steadiness, GraphType.Less),
        PlotPoint(7, 107, Attribute.Steadiness, GraphType.Less),
        PlotPoint(8, 115, Attribute.Steadiness, GraphType.Less),
        PlotPoint(9, 132, Attribute.Steadiness, GraphType.Less),
        PlotPoint(10, 148, Attribute.Steadiness, GraphType.Less),
        PlotPoint(11, 162, Attribute.Steadiness, GraphType.Less),
        PlotPoint(12, 173, Attribute.Steadiness, GraphType.Less),
        PlotPoint(13, 178, Attribute.Steadiness, GraphType.Less),
        PlotPoint(16, 183, Attribute.Steadiness, GraphType.Less),
        PlotPoint(19, 188, Attribute.Steadiness, GraphType.Less),
        PlotPoint(0, 4, Attribute.Compliance, GraphType.Less),
        PlotPoint(1, 10, Attribute.Compliance, GraphType.Less),
        PlotPoint(2, 28, Attribute.Compliance, GraphType.Less),
        PlotPoint(3, 49, Attribute.Compliance, GraphType.Less),
        PlotPoint(4, 66, Attribute.Compliance, GraphType.Less),
        PlotPoint(5, 81, Attribute.Compliance, GraphType.Less),
        PlotPoint(6, 91, Attribute.Compliance, GraphType.Less),
        PlotPoint(7, 99, Attribute.Compliance, GraphType.Less),
        PlotPoint(8, 107, Attribute.Compliance, GraphType.Less),
        PlotPoint(9, 126, Attribute.Compliance, GraphType.Less),
        PlotPoint(10, 139, Attribute.Compliance, GraphType.Less),
        PlotPoint(11, 162, Attribute.Compliance, GraphType.Less),
        PlotPoint(12, 168, Attribute.Compliance, GraphType.Less),
        PlotPoint(13, 173, Attribute.Compliance, GraphType.Less),
        PlotPoint(15, 183, Attribute.Compliance, GraphType.Less),
        PlotPoint(17, 188, Attribute.Compliance, GraphType.Less),
    )

    val GRAPH_FORMAT_DIFFERENCE = listOf(
        PlotPoint(-20, 9, Attribute.Dominance, GraphType.Difference),
        PlotPoint(-16, 13, Attribute.Dominance, GraphType.Difference),
        PlotPoint(-12, 28, Attribute.Dominance, GraphType.Difference),
        PlotPoint(-11, 34, Attribute.Dominance, GraphType.Difference),
        PlotPoint(-10, 44, Attribute.Dominance, GraphType.Difference),
        PlotPoint(-9, 52, Attribute.Dominance, GraphType.Difference),
        PlotPoint(-7, 59, Attribute.Dominance, GraphType.Difference),
        PlotPoint(-6, 66, Attribute.Dominance, GraphType.Difference),
        PlotPoint(-4, 82, Attribute.Dominance, GraphType.Difference),
        PlotPoint(-3, 86, Attribute.Dominance, GraphType.Difference),
        PlotPoint(-2, 90, Attribute.Dominance, GraphType.Difference),
        PlotPoint(0, 94, Attribute.Dominance, GraphType.Difference),
        PlotPoint(1, 102, Attribute.Dominance, GraphType.Difference),
        PlotPoint(3, 108, Attribute.Dominance, GraphType.Difference),
        PlotPoint(5, 114, Attribute.Dominance, GraphType.Difference),
        PlotPoint(7, 122, Attribute.Dominance, GraphType.Difference),
        PlotPoint(8, 136, Attribute.Dominance, GraphType.Difference),
        PlotPoint(9, 142, Attribute.Dominance, GraphType.Difference),
        PlotPoint(10, 157, Attribute.Dominance, GraphType.Difference),
        PlotPoint(12, 163, Attribute.Dominance, GraphType.Difference),
        PlotPoint(13, 169, Attribute.Dominance, GraphType.Difference),
        PlotPoint(14, 174, Attribute.Dominance, GraphType.Difference),
        PlotPoint(15, 179, Attribute.Dominance, GraphType.Difference),
        PlotPoint(18, 184, Attribute.Dominance, GraphType.Difference),
        PlotPoint(21, 189, Attribute.Dominance, GraphType.Difference),
        PlotPoint(-18, 9, Attribute.Influence, GraphType.Difference),
        PlotPoint(-10, 13, Attribute.Influence, GraphType.Difference),
        PlotPoint(-9, 18, Attribute.Influence, GraphType.Difference),
        PlotPoint(-8, 28, Attribute.Influence, GraphType.Difference),
        PlotPoint(-7, 38, Attribute.Influence, GraphType.Difference),
        PlotPoint(-6, 44, Attribute.Influence, GraphType.Difference),
        PlotPoint(-5, 52, Attribute.Influence, GraphType.Difference),
        PlotPoint(-4, 59, Attribute.Influence, GraphType.Difference),
        PlotPoint(-3, 77, Attribute.Influence, GraphType.Difference),
        PlotPoint(-2, 82, Attribute.Influence, GraphType.Difference),
        PlotPoint(-1, 94, Attribute.Influence, GraphType.Difference),
        PlotPoint(0, 102, Attribute.Influence, GraphType.Difference),
        PlotPoint(1, 108, Attribute.Influence, GraphType.Difference),
        PlotPoint(2, 114, Attribute.Influence, GraphType.Difference),
        PlotPoint(3, 128, Attribute.Influence, GraphType.Difference),
        PlotPoint(4, 142, Attribute.Influence, GraphType.Difference),
        PlotPoint(5, 148, Attribute.Influence, GraphType.Difference),
        PlotPoint(6, 163, Attribute.Influence, GraphType.Difference),
        PlotPoint(7, 169, Attribute.Influence, GraphType.Difference),
        PlotPoint(8, 179, Attribute.Influence, GraphType.Difference),
        PlotPoint(10, 184, Attribute.Influence, GraphType.Difference),
        PlotPoint(18, 189, Attribute.Influence, GraphType.Difference),
        PlotPoint(-18, 4, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(-15, 9, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(-10, 18, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(-9, 38, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(-8, 44, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(-7, 52, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(-6, 59, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(-5, 77, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(-4, 82, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(-3, 86, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(-2, 90, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(-1, 94, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(0, 108, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(1, 114, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(2, 120, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(3, 128, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(4, 136, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(5, 142, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(7, 157, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(8, 163, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(9, 169, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(10, 174, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(11, 179, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(15, 184, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(20, 189, Attribute.Steadiness, GraphType.Difference),
        PlotPoint(-22, 4, Attribute.Compliance, GraphType.Difference),
        PlotPoint(-19, 9, Attribute.Compliance, GraphType.Difference),
        PlotPoint(-15, 13, Attribute.Compliance, GraphType.Difference),
        PlotPoint(-13, 18, Attribute.Compliance, GraphType.Difference),
        PlotPoint(-10, 28, Attribute.Compliance, GraphType.Difference),
        PlotPoint(-9, 38, Attribute.Compliance, GraphType.Difference),
        PlotPoint(-8, 44, Attribute.Compliance, GraphType.Difference),
        PlotPoint(-7, 52, Attribute.Compliance, GraphType.Difference),
        PlotPoint(-6, 59, Attribute.Compliance, GraphType.Difference),
        PlotPoint(-5, 66, Attribute.Compliance, GraphType.Difference),
        PlotPoint(-4, 90, Attribute.Compliance, GraphType.Difference),
        PlotPoint(-3, 94, Attribute.Compliance, GraphType.Difference),
        PlotPoint(-2, 102, Attribute.Compliance, GraphType.Difference),
        PlotPoint(-1, 108, Attribute.Compliance, GraphType.Difference),
        PlotPoint(0, 114, Attribute.Compliance, GraphType.Difference),
        PlotPoint(1, 128, Attribute.Compliance, GraphType.Difference),
        PlotPoint(2, 142, Attribute.Compliance, GraphType.Difference),
        PlotPoint(3, 148, Attribute.Compliance, GraphType.Difference),
        PlotPoint(4, 169, Attribute.Compliance, GraphType.Difference),
        PlotPoint(5, 174, Attribute.Compliance, GraphType.Difference),
        PlotPoint(6, 179, Attribute.Compliance, GraphType.Difference),
        PlotPoint(10, 184, Attribute.Compliance, GraphType.Difference),
        PlotPoint(17, 189, Attribute.Compliance, GraphType.Difference),
        )
}